/**
 * ¿A qué backend puede apuntar una corrida "contra otra URL"?
 *
 * `postGenerateContra` adjunta el JWT de Supabase — la credencial COMPLETA de la
 * sesión — a una URL que se tipea en un input libre. Mandarla a un origen
 * arbitrario se la regala a ese servidor, que puede replayearla contra nuestra
 * API mientras dure la sesión. Que la página sea solo dev_tester no lo salva:
 * alcanza con que a un tester le pasen "probá contra esta URL".
 *
 * La feature existe para UNA cosa (ver el comment de `postGenerateContra`):
 * comparar contra un worktree corriendo en ESTA máquina, en otro puerto. Así que
 * la allowlist es exactamente eso — hosts locales — más el origen del backend
 * propio (`ATLAS_BACKEND_URL`), que ya recibe este token en cada request normal
 * y cubre el caso "front local comparando contra prod".
 */
export function esBackendDePruebaPermitido(
  baseUrl: string,
  backendPropio?: string,
): boolean {
  let url: URL;
  try {
    url = new URL(baseUrl);
  } catch {
    return false;
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
  if (
    url.hostname === 'localhost' ||
    url.hostname === '127.0.0.1' ||
    // WHATWG URL deja los corchetes en el hostname IPv6.
    url.hostname === '[::1]'
  ) {
    return true;
  }
  if (backendPropio) {
    try {
      return new URL(backendPropio).origin === url.origin;
    } catch {
      return false;
    }
  }
  return false;
}
